import { useMutation } from "@tanstack/react-query";
import {
  UsersApiResetPasswordRequest,
  buildUsersApi,
} from "@rentablo/api/apiv1";

const assignPassword = async (params: UsersApiResetPasswordRequest) => {
  const api = buildUsersApi();

  const { data } = await api.resetPassword(params);
  return data;
};

export const useAssignPassword = () => {
  return useMutation<
    void,
    AxiosApiError,
    UsersApiResetPasswordRequest,
    unknown
  >({
    mutationFn: assignPassword,
  });
};
